import apiClient from './client';

// Creator discovery — searches the pool of streamers/channels the platform has
// seen (on or off the roster). Reads the database only; no API quota per search.
export const discoveryAPI = {
  filters: (platform) => apiClient.get('/discovery/filters', { params: { platform } }),
  searchGames: (q) => apiClient.get('/discovery/games', { params: { q } }),
  addGame: (twitchGameId, title) => apiClient.post('/discovery/games', { twitchGameId, title }),
  search: (params) => apiClient.get('/discovery/search', { params, timeout: 30000 }),
  add: (platform, externalId) => apiClient.post('/discovery/add', { platform, externalId }),

  // Shortlists: save creators, enrich contact details (official APIs only,
  // capped per day), export CSV, add everyone to the roster in one go.
  shortlists: () => apiClient.get('/discovery/shortlists'),
  createShortlist: (name) => apiClient.post('/discovery/shortlists', { name }),
  deleteShortlist: (id) => apiClient.delete(`/discovery/shortlists/${id}`),
  shortlist: (id) => apiClient.get(`/discovery/shortlists/${id}`),
  // `context` = why they were shortlisted: { gameId, gameTitle, genre, windowLabel, metrics }
  shortlistAdd: (id, platform, externalId, context) => apiClient.post(`/discovery/shortlists/${id}/items`, { platform, externalId, context }),
  shortlistRemove: (id, itemId) => apiClient.delete(`/discovery/shortlists/${id}/items/${itemId}`),
  shortlistEnrich: (id) => apiClient.post(`/discovery/shortlists/${id}/enrich`, {}, { timeout: 120000 }),
  shortlistAddAll: (id) => apiClient.post(`/discovery/shortlists/${id}/add-all`, {}, { timeout: 120000 }),
  // The export needs the auth header, so it is fetched as a blob and saved
  // client-side rather than opened as a plain link.
  shortlistExport: (id) => apiClient.get(`/discovery/shortlists/${id}/export.csv`, { responseType: 'blob', timeout: 120000 }),
};
